import { BoxProps } from 'app/src/kit/primitives/themeMappings/props'
import { css, styled } from 'styled-components'

export interface SeparatorBoxProps extends BoxProps {
  $isSeparatorHidden?: boolean
}

const SeparatorBox = styled(Box)<SeparatorBoxProps>`
  width: 100%;
  height: 1px;

  ${(p) =>
    !p.$isSeparatorHidden &&
    css`
      border-top: 1px solid ${p.theme.colors.grayscale[100]};
    `}
`

export default SeparatorBox
